import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Section from '@common/Section';
import Row from '@common/Row';
import RichText from '@common/RichText';
import Img from '@common/Image';
import Button from '@common/Button';
import SmallTitle from '@common/SmallTitle';

import Video from '@common/blocks/flex/Video';
import Buttons from '@common/blocks/flex/Buttons';
import Images from '@common/blocks/flex/Images';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, A11y } from 'swiper/modules';

import * as styles from '@common/blocks/flex/flex.module.scss';

const TextWithLinkSlider = ({ data }) => {
  const {
    title,
    showTitle,
    showBorder,
    text,
    textAlignment,
    textFontSize,
    textFontFamily,
    textColWidth,
    listClass,
    imagePosition,
    imagePositionTop,
    imagePositionTopLg,
    imageNegativeMargin,
    buttons,
    images,
    links,
    video,
    topMargin,
    bottomMargin,
    bgColour,
    bgPadding,
    bgFullwidth
  } = data;
  return (
    <Section style={{ marginTop: `calc(${imageNegativeMargin} + 50px)` }} spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx({
        [`bg-${bgColour}`]: bgColour,
        [bgPadding]: bgColour,
        ['container']: !bgFullwidth,
        [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop
      })}>
      <Container>
        {video &&
          <Video data={data}/>
        }
        <div className={clsx(`d-flex flex-column align-items-center`, {
            'flex-lg-row-reverse': imagePosition === 'Left' && !imagePositionTopLg,
            'flex-lg-row': imagePosition === 'Right' && !imagePositionTopLg,
            'flex-column-reverse': imagePositionTop || imagePositionTopLg,
            'justify-content-center': (!images || !links) && textAlignment === 'Center',
            'border border-dark-grey-4 border-3 rounded-3 px-3 py-3 py-lg-5': showBorder
          })}>
          {(text || buttons) &&
            <div className={clsx('col pe-lg-1', textColWidth, {
                'text-center': textAlignment === 'Center',
                'text-end': textAlignment === 'Right',
                'text-start': textAlignment === 'Left',
              })}>
              {(showTitle && title) &&
                <SmallTitle>{title}</SmallTitle>
              }
              {text &&
                <RichText
                  json={text}
                  h1='mb-3'
                  h2='mb-3'
                  p={clsx('mb-3', textFontSize, textFontFamily)}
                  a='fs-16'
                  ul={listClass}
                />
              }
              {buttons && 
                <Buttons data={data} />
              }
            </div>
          }
          {images &&
            <Images data={data} />
          }
          {links &&
            <div className='d-none d-lg-block col-6 ps-lg-1'>
              {links &&
                <Swiper
                  pagination={{
                    el: '.swiper-pagination-custom',
                    type: 'bullets',
                    clickable: true
                  }}
                  modules={[Pagination, A11y]}
                  slidesPerView={1}
                  spaceBetween={20}
                  >
                  {links.map((link, index) => (
                    <SwiperSlide key={index}>
                      <div className={clsx('d-flex position-relative p-4 mt-5 rounded-3', {[`bg-${link.bgColour}`]:link.bgColour})}>
                        <div className='col col-6 d-flex flex-column justify-content-between position-relative'>
                          <div className='d-flex flex-column align-items-start pe-1'>
                            {link.subtitle && <div className='text-uppercase fw-medium fs-16 mb-2'>{link.subtitle}</div>}
                            {link.title && <div className='fw-medium fs-24 mb-4'>{link.title}</div>}
                          </div>
                          {link.link &&
                            <div>
                              <Button
                                variant='primary'
                                to={link.link}
                                copy={link.linkCopy}
                              />
                            </div>
                          }
                        </div>
                        <div className='col text-center overflow-hidden rounded' style={{marginTop: -120}}>
                          <Img image={link.image.gatsbyImageData} file={link.image.file} className='rounded' />
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              }
              <div className='swiper-pagination-custom d-flex justify-content-center mt-3'/>
            </div>
          }
        </div>
        {links &&
          <div className='col d-lg-none'>
            {links &&
              <Swiper
                pagination={{
                  el: '.swiper-pagination-custom-mobile',
                  type: 'bullets',
                  clickable: true
                }}
                modules={[Pagination, A11y]}
                slidesPerView={1}
                spaceBetween={20}
                >
                {links.map((link, index) => (
                  <SwiperSlide key={index}>
                    <div className={clsx('d-flex position-relative p-4 mt-5 rounded-3', {[`bg-${link.bgColour}`]:link.bgColour})}>
                      <div className='col col-6 d-flex flex-column justify-content-between position-relative'>
                        <div className='d-flex flex-column align-items-start pe-1'>
                          {link.subtitle && <div className='text-uppercase fw-medium fs-16 mb-2'>{link.subtitle}</div>}
                          {link.title && <div className='fw-medium fs-24 mb-4'>{link.title}</div>}
                        </div>
                        {link.link &&
                          <div>
                            <Button
                              variant='primary'
                              to={link.link}
                              copy={link.linkCopy}
                            />
                          </div>
                        }
                      </div>
                      <div className='col text-center overflow-hidden rounded'>
                        <Img image={link.image.gatsbyImageData} file={link.image.file} className='rounded' imgStyle={{borderRadius: 10}} />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            }
            <div className='swiper-pagination-custom-mobile d-flex justify-content-center mt-3'/>
          </div>
        }
      </Container>
    </Section>
  )
}

export default TextWithLinkSlider
